import { render, staticRenderFns } from "./CopilotChart.vue?vue&type=template&id=30feb787"
import script from "./CopilotChart.vue?vue&type=script&lang=ts"
export * from "./CopilotChart.vue?vue&type=script&lang=ts"
import style0 from "./CopilotChart.vue?vue&type=style&index=0&id=30feb787&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports